import { app_placeholder } from '../../../env.placeholders';
import { HttpArcgis } from '../../http';
import { LocalStorage } from '../../localStorage';
import { prepareMultipleInseeCodesRequest } from '../map/defExpHelper';

// formated data hence dropdownlists and table data
export const formatedDataIndus = async (pData: any[], pMode: string) => {
  let data: any[] = [];
  pData.forEach((feat) => {
    if (pMode === 'ActivityLabel') {
      data.push({
        name: feat['attributes'].ActivityLabel,
        code: feat['attributes'].ActivityLabel.replaceAll("'", "''"),
      });
    } else if (pMode === '*') {
      // get geometry for zoom
      feat['attributes'].geometry = feat['geometry'];
      feat['attributes'].communeBc = Array.isArray(
        JSON.parse(window.sessionStorage.getItem('indus_commune')!)
      )
        ? ''
        : JSON.parse(window.sessionStorage.getItem('indus_commune')!)?.name;
      data.push(feat['attributes']);
    } else {
      data.push(feat['attributes']);
    }
  });
  return data;
}

// request for indus to provide data for dropdownlists (section, option) and table
export const requestForIndus = async (pFormBodyToSend: any, pMode: string) => {
  let data: any[] = [];
  try {
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/80/query',
      JSON.stringify(pFormBodyToSend)
    );
    let datas: any[] = [];
    if (
      responseSections.status === 200 &&
      responseSections.data.features !== undefined
    ) {
      datas = responseSections.data.features;
      // get attibutes
      data = await formatedDataIndus(datas, pMode);
    } else {
      console.log('Failed to provide data for indus table !');
    }
  } catch (error) {
    console.log('Failed to get data for dropdownlist !', error);
  }
  return data;
};

// custome creation of query
export const createQueryIndus = (pQuery: string, pOutField: string, pInputGeom: any) => {
  const formBody: string[] = [];
  // for all request
  formBody.push('where=' + pQuery);
  formBody.push('outFields=' + pOutField);

  // specific cases : collection pool
  if (pInputGeom !== undefined) {
    formBody.push('geometry=' + JSON.stringify(pInputGeom));
    formBody.push('geometryType=esriGeometryPolyline');
    formBody.push('spatialRel=esriSpatialRelContains');
    formBody.push('distance=100');
    formBody.push('units=esriSRUnit_Meter');
  }

  if (pOutField === 'SectionLabel' || pOutField === 'ActivityLabel') {
    // for options of section / activity
    formBody.push('returnGeometry=false');
    formBody.push('returnDistinctValues=true');
  } else {
    formBody.push('returnGeometry=true');
    formBody.push('resultRecordCount=1000');
  }

  // for options of section
  if (pOutField === 'SectionLabel' || pOutField === 'ActivityLabel') {
    formBody.push('orderByFields=' + pOutField);
  }

  // for all request
  formBody.push('f=json');
  formBody.push('user=' + LocalStorage.userMail.get());
  return formBody.join('&');
}

export const getDataIndus = async (
  pFilters: any,
  pQuery: string,
  pAllCommunes: any,
) => {
  // prepare queries
  let data: any[] = [];
  let query: string = '';
  let inputGeom;
  // BC or Commune selected
  if (Array.isArray(pFilters['InseeCode'].paths) === true) {
    // when a collection pool is selected
    inputGeom = {
      hasM: true,
      paths: pFilters['InseeCode'].paths,
      spatialeReference: {
        wkid: 4326,
      },
    };
  } else {
    // when a commune is selected
    if (pFilters['InseeCode'].code !== '') {
      query = "InseeCode in('" + pFilters['InseeCode'].code + "')";
    } else {
      // when communes are provided
      if (pAllCommunes.length !== 0) {
        query =
          'InseeCode in(' +
          prepareMultipleInseeCodesRequest(pAllCommunes) +
          ')';
      } else {
        // when no communes are provided
        console.log('No communes provided !');
      }
    }
  }

  // form for request sevice
  let inputQuery = query;
  if (pQuery !== '') {
    inputQuery = (query !== '' ? query + ' AND ' : '') + pQuery;
  }
  const formBodyToSend = createQueryIndus(
    inputQuery,
    'OBJECTID,Name,ActivityLabel,Global_Note,SalariedWorkforceSlice,Color,NAF_Note,RSDE_Note,WarsmannNote,City,SectionLabel',
    inputGeom
  );
  data = await requestForIndus(formBodyToSend, '*');

  return data;
};

// define spatial filter collection pool or commune
export const getSpatialFilter = (pFilters: object, pAllInseeCodesContract: any[]) => {
  let spatialFilter: string = '';
  let inputGeom;
  let mode: string = '';
  // we need communes to get main activities
  if (pFilters['InseeCode'].paths !== '') {
    // bc selected
    let pathsBC = pFilters['InseeCode'].paths;
    inputGeom = {
      hasM: true,
      paths: pathsBC,
      spatialeReference: {
        wkid: 4326,
      },
    };
    mode = 'collectionPool';
  } else {
    mode = 'commune';
    if (pFilters['InseeCode'].code !== '') {
      let req = "'" + pFilters['InseeCode'].code + "'";
      spatialFilter = 'InseeCode in (' + req + ')';
    } else {
      // all communes selected
      if (pAllInseeCodesContract.length !== 0) {
        let inseeCodes = prepareMultipleInseeCodesRequest(
          pAllInseeCodesContract
        );
        spatialFilter = 'InseeCode in (' + inseeCodes + ')';
      }
    }
  }
  return { spatialFilter: spatialFilter, inputGeom: inputGeom, mode: mode };
};

export const avoidDuplicate = (pArray: any[], pOutfield: string) => {
  return pArray.reduce((acc: any, obj) => {
    if (!acc.some((o: any) => o[pOutfield] === obj[pOutfield])) {
      acc.push(obj);
    }
    return acc;
  }, []);
};
